import SectionHeader from "../../../util/component/SectionHeader";
import VehicleMaintanence from "../component/vehicleMaintanence/VehicleMaintanence";
import useOperationTranslation from "../hooks/useOperationTranslation";

const Maintenance = () => {
    const t = useOperationTranslation();

    return(
        <>
            <SectionHeader
                title={t("vehicleMaintenance.title")}
            />

            <VehicleMaintanence />
        </>
    )
}
export default Maintenance;